import React from 'react'
import Charts from './Charts'

function Dashboard() {
  return (
    <div>
      <Charts/>
    </div>
  )
}

export default Dashboard
